import React from 'react';
import { Tag as AntTag } from 'antd';
import styled from 'styled-components';

const colorMap = {
  default: 'var(--greyscale-blackish)',
  blue: 'var(--primary-oqio-blue)',
  red: 'var(--primary-oqio-red)',
  grey: 'var(--greyscale-shade)',
  green: 'var(--primary-oqio-green)'
};

const StyledTag = styled(AntTag)`
  background-color: ${({ $background }) => colorMap[$background] || colorMap.default};
  border: none;
  border-radius: var(--border-radius-medium);
  color: var(--greyscale-white) !important;
  font-weight: var(--font-weight-semi-bold);
  height: 20px;
  line-height: 16px;
  padding: 2px 10px;
  width: max-content;
`;

const getStatusMeta = (status) => {
  switch (status) {
    case 'rejected':
      return { label: 'Abgelehnt', color: 'red' };
    case 'open':
      return { label: 'Offen', color: 'blue' };
    case 'closed':
      return { label: 'Geschlossen', color: 'green' };
    case 'canceled':
      return { label: 'Storniert', color: 'grey' };
    default:
      return { label: status, color: 'default' };
  }
};

export const StatusTag = ({ background = 'default', children, status, ...rest }) => {
  const { label, color } = status ? getStatusMeta(status) : { label: children, color: background };

  return (
    <StyledTag $background={color} {...rest}>
      {label}
    </StyledTag>
  );
};
